import request from '@/utils/request';

export function index(params) {
  return request({
    url: '/wx/user/index',
    method: 'get',
    params: params,
  });
}

//修改用户短信通知
export function updateShipSmsSwitch(data) {
  return request({
    url: '/wx/user/updateShipSmsSwitch',
    method: 'post',
    data: data,
  });
}

//获取客服链接
export function getCutomerLink(phone, product) {
  return request({
    url: '/wx/index/getCustmerLink/' + phone + '?product=' + product,
    method: 'get',
  });
}



//获取业务员下绑定的企业列表
export function getEnterpriseByUserId(userId) {
  return request({
    url: '/wx/enterprise/user/enterprise/' + userId,
    method: 'get',
  });
}
export function getErpUserByDept(query) {
  return request({
    url: "/wx/user/getErpListByDept",
    method: "get",
    params: query,
  });
}



// WEBPACK FOOTER //
// ./src/api/user/user.js